/* global Profile Search */
var ActionTracker = function() {
    return {
        record: function(action) {
            Ajax.recordAction(action);
        }
    };
}();

var LinkTracker = function() {
    return {
        init: function(link_ids, sampling) {
            if (Math.random() < 1 / sampling) {
                Ajax.sendLinkTrackerImps(link_ids);
            }
        },
    };
}();


var Account = function() {

    var handleRegisterUsername = function() {
        if (($('#newusername').val().length < 3)) {
            alert('Λάθος όνομα χρήστη');
            return;
        }
        if (!$('#user-optin').is(':checked')) {
            alert('Δεν επιλέξατε ότι συμφωνείτε με τους όρους χρήσης');
            return;
        }
        Ajax.subscribeSave({
            username: $('#newusername').val(),
            newsletter: $('#user-newsletter').is(':checked') ? 1 : 0,
            g_register: $('#g_register').val(),
        }, function(data) {
            if (data.success == 'failed') {
                alert(data.error);
                return;
            }
            window.location.href = window.location.href.split('?')[0];
        });
    };

    var handle_login = function() {
        $('#cred_prompt').html('');
        localStorage['scroll'] = $(window).scrollTop();
        var data = {
            username: $('#login_username').val(),
            password: $('#login_password').val(),
        };
        if (data.username != '' && data.password != '') {
            Generic.showProgressLoader();
            Ajax.login($('#login_username').val(), $('#login_password').val(), function(res) {
                if (res.success == 'ok') {
                    window.location.reload(true);
                } else {
                    $('#cred_prompt').html('Λάθος Στοιχεία');
                }
                Generic.hideProgressLoader();
            });
        } else {
            $('#cred_prompt').html('Συμπληρώστε username ή email και password');
        }
    };

    var handle_reset_pwd = function() {
        localStorage['scroll'] = $(window).scrollTop();
        if ($('#reset_form')[0].checkValidity()) {
            var email = $('#forgot_pass_email').val();
            if (email) {
                Ajax.forgotPwd(email, function(res) {
                    if (res.success == 'ok' && res.html) {
                        $('#forgot_pwd_modal_body').html(res.html);
                    }
                });
            }
        } else {
            $('#reset_form').addClass('was-validated');
        }
    };

    var handle_register = function() {
        if (!Subscribe.verify()) {
            $('#register_btn').prop('disabled', false);
            return;
        }
        var data = {
            email: $('#email-input').val(),
            username: $('#username-input').val(),
            password: $('#register_password').val(),
            newsletter: $('#newsletter').is(':checked') ? 1 : 0
        };

        Ajax.subscribeSave(data, function(data) {
            if (data.success == 'failed') {
                $('#register_btn').prop('disabled', false);
                alert(data.error);
                return;
            }
            window.location.href = window.location.href.split('?')[0];
        }, function(res) {
            $('#register_btn').prop('disabled', false);
            res.text().then((resTxt) => {
                Generic.alert('Αποτυχία Εγγραφής', resTxt, true);
            });
        });
    };

    return {
        init: function() {
            $('#register-username-btn').click(function() {
                handleRegisterUsername();
            });
        },
        init_handlers: function() {
            $('#logoff_anchor').click(function() {
                localStorage['scroll'] = $(window).scrollTop();
                Ajax.logoff(function() {
                    window.location.reload(true);
                });
            });

            $('#login_btn').click(function() {
                handle_login();
            });

            $('#login_password').keyup(function(ev) {
                if (ev.which == 13) {
                    handle_login();
                }
            });

            $('#login_modal').on('hidden.bs.modal', function() {
                $('#login_username').val('');
                $('#login_password').val('');
                $('#cred_prompt').html('');
            });

            $('#reset_pwd_btn').click(function() {
                handle_reset_pwd();
            });

            $('#forgot_pass_email').keyup(function(ev) {
                if (ev.which == 13) {
                    handle_reset_pwd();
                }
            });

            $('#forgot_pwd_modal').on('hidden.bs.modal', function() {
                $('#reset_form').removeClass('was-validated');
                $('#forgot_pwd_modal_body')
                    .replaceWith('\
                        <div class="modal-body" id="forgot_pwd_modal_body">\
                            <p>Εισάγετε το email σας για να σας στείλουμε το username σας και να δώσετε νέο password.</p>\
                            <div class="row">\
                                <div class="col-9">\
                                    <form action="javascript:void(0);" class="form form--box needs-validation" id="reset_form" novalidate>\
                                        <label>e-mail:</label>\
                                        <input type="email" id="forgot_pass_email" class="form-control mb-1" required>\
                                        <div class="invalid-feedback mb-2">\
                                            Συμπληρώστε σωστά το email σας.\
                                        </div>\
                                        <button type="button" id="reset_pwd_btn" class="btn btn-block btn-primary">Reset Password</button>\
                                    </form>\
                                </div>\
                            </div>\
                        </div>\
                    ');
                Account.init_handlers();
            });

            $('#register_btn').click(function() {
                $(this).prop('disabled', true);
                handle_register();
            });

            $('#register_password2').keyup(function(ev) {
                if (ev.which == 13) {
                    $('#register_btn').prop('disabled', true);
                    handle_register();
                }
            });

            $('#register_modal').on('hidden.bs.modal', function() {
                $('.ii__register_checks').html('');
            });

            $('#register_modal').on('shown.bs.modal', function() {
                $('body').addClass('modal-open');
            });

            $('.ii__oauth_btn').click(function(ev) {
                ev.preventDefault();
                Generic.jsCookies.setItem('REDIRECT', window.location.pathname, 60 * 5, '/');
                document.location.href = $(this).attr('href');
            });
        }
    };
}();


var Generic = function() {
    var update_desc_toggle_btn = function() {
        if (!$('#desc_collapse_btn').hasClass('collapsed')) {
            window.scrollTo({top: 0});
            $('#desc_collapse_btn').html('+ Διαβάστε ολόκληρη την περιγραφή');
        } else {
            setTimeout (function() {
                $('#desc_collapse_btn').html('- Απόκρυψη περιγραφής');
            }, 500);

        }
    };

    var parseAndRenderTenorResponse = function(res, targetgallery, show_limit) {
        let total = 0,
            html = ''
        ;
        if (res && !res.error && res.results && Array.isArray(res.results)) {
            for (const gif of res.results) {
                if (!gif.media_formats) {
                    continue;
                }
                let img, preview;
                if (gif.media_formats.mediumgif && gif.media_formats.mediumgif.url) {
                    img = gif.media_formats.mediumgif;
                } else if (gif.media_formats.gif && gif.media_formats.gif.url) {
                    img = gif.media_formats.gif;
                } else {
                    continue;
                }
                if (gif.media_formats.nanowebm && gif.media_formats.nanowebm.url) {
                    preview = gif.media_formats.nanowebm;
                } else if (gif.media_formats.tinywebm && gif.media_formats.tinywebm.url) {
                    preview = gif.media_formats.tinywebm;
                } else {
                    continue;
                }
                html += `
                    <video data-url="${img.url}" onclick="Generic.gif_click_handler(this);" style="cursor:pointer;" autoplay loop>
                        <source src="${preview.url}"/>
                    </video>
                `;
                if (++total == show_limit) {
                    break;
                }
            }
            targetgallery.html(html).removeClass('loading');
        }
    };

    var fetchAndShowFeaturedGifs = function(fetch_limit, targetgallery, show_limit) {
        Ajax.getFeaturedGifs(fetch_limit, function(res) {
            parseAndRenderTenorResponse(res, targetgallery, show_limit);
        });
    };

    var searchAndShowGifs = function(q, fetch_limit, targetgallery, show_limit) {
        Ajax.searchGifs(q, fetch_limit, function(res) {
            parseAndRenderTenorResponse(res, targetgallery, show_limit);
        });
    };

    return {
        append_to_input: function(selector, what) {
            var e = $(selector);
            e.val(e.val() + what);
            e.focus();
        },

        init_gifemoji_enabled_input: function() {
            var FETCH_LIMIT = 45;
            var SHOW_LIMIT = 35;

            $('.ii__gif_toggle_button').click(function() {
                $('.ii__gif_search').val('');
                var targetgallery = $('#' + $(this).data('targetgallery'));
                targetgallery.html('').addClass('loading');
                fetchAndShowFeaturedGifs(FETCH_LIMIT, targetgallery, SHOW_LIMIT);

            });

            $('.ii__gif_search').keyup(function() {
                var targetgallery = $('#' + $(this).data('targetgallery'));
                targetgallery.html('').addClass('loading');
                var q = $(this).val();
                if (q == '') {
                    fetchAndShowFeaturedGifs(FETCH_LIMIT, targetgallery, SHOW_LIMIT);
                } else {
                    searchAndShowGifs(q, FETCH_LIMIT, targetgallery, SHOW_LIMIT);
                }

            });


            $('.ii__emoji_toggle_button').click(function() {
                var html = '';
                for (var ix in Generic.emojis) {
                    html += '<button type="button" class="btn-clean ii__emoji_selected" onclick="Generic.emoji_click_handler(this);">' +
                        Generic.emojis[ix] + '</button> ';
                }
                $('#' + $(this).data('targetgallery')).html(html);
            });
        },

        emoji_click_handler: function(e) {
            Generic.append_to_input(
                '#' + $(e).parent().data('targetinput'), $(e).text());
            $('.dropdown-submenu .dropdown-menu').removeClass('show');
        },

        gif_click_handler: function(e) {
            $('#' + $(e).parent().data('targetinput')).val('~~' + encodeURIComponent($(e).data('url')) + '~~');
            $('#' + $(e).parent().data('targetsubmit')).click();
            $('.dropdown-submenu .dropdown-menu').removeClass('show');
        },

        enable_accordion: function() {
            $('.accordion-group-label').click(function(e) {
                $('.accordion-group-items.' + $(this).data('group')).toggle();
                if ($(this).find('.fa-caret-down').length > 0) {
                    $(this).find('.fa-caret-down').removeClass('fa-caret-down').addClass('fa-caret-up');
                } else {
                    $(this).find('.fa-caret-up').removeClass('fa-caret-up').addClass('fa-caret-down');
                }
                if ($('#m_analysi:not(.collapsed)').length > 0) {
                    $('#m_analysi:not(.collapsed)').height(
                        Math.max(
                            $('#analyseis_submenu').innerHeight(),
                            $('#m_analysi')[0].scrollHeight));
                }
            });
        },
        change_hash_without_scroll: function(hash) {
            if (hash.charAt(0) != '#') {
                hash = '#' + hash;
            }
            if (history.replaceState != undefined) {
                history.replaceState(undefined, undefined, hash);
            } else {
                location.replace(hash);
            }
        },
        startsWith: function(inStr, searchString) {
            return inStr.indexOf(searchString, 0) === 0;
        },

        log_error: function(msg) {
            if (Generic.sentry_js_url == '' || (typeof Sentry === 'undefined')) {
                console.warn(msg);
            } else {
                if (!Generic.sentry) {
                    Sentry.init({dsn: Generic.sentry_js_url});
                }
                Sentry.captureMessage(msg);
            }
        },
        toggle_theme: function() {
            if (Generic.theme === 1) {
                Generic.theme = 0;
                $('.page').removeClass('dark');
            } else {
                Generic.theme = 1;
                $('.page').addClass('dark');
            }
            Ajax.savePrefTheme(Generic.theme);
        },
        toggle_button_init: function(toggle_class, toggle_target_class) {
            $('.' + toggle_class + '.ii__smallbutton').click(function(e) {
                $('.' + toggle_class).removeClass('active');
                $(e.target).addClass('active');
                $('.' + toggle_target_class).hide();
                $('.' + $(e.target).data('target')).show();
            });
        },
        show_more_button_init: function() {
            if ($('.showmore_btn').length == 0 || Generic.show_more_button_inited) {
                return;
            }
            Generic.show_more_button_inited = true;
            $('.showmore_btn').click(function() {
                if (!$(this).data('toggletarget') || $('.' + $(this).data('toggletarget')).length == 0) {
                    return;
                }
                $('.' + $(this).data('toggletarget') + ':hidden').slice(0,10).show();
                if ($('.' + $(this).data('toggletarget') + ':hidden').length == 0) {
                    $(this).hide();
                }
            });
        },
        show_all_button_init: function() {
            if (Generic.show_all_button_inited) {
                return;
            }
            Generic.show_all_button_inited = true;
            $(document).on('click', '.ii__showall_btn', function(e){
                if (!$(this).data('toggletarget') || $('.' + $(this).data('toggletarget')).length == 0) {
                    return;
                }
                if ($(this).data('toggletext') != undefined) {
                    var t = $(this).data('toggletext');
                    $(this).data('toggletext', $(this).html());
                    if ($('.' + $(this).data('toggletarget')).first().hasClass('invisible')) {
                        $('.' + $(this).data('toggletarget')).removeClass('invisible');
                    } else {
                        $('.' + $(this).data('toggletarget')).addClass('invisible');
                    }
                    $(this).html(t);
                } else {
                    $('.' + $(this).data('toggletarget')).removeClass('invisible');
                    $(this).hide();
                }
            });
        },
        comment: function(mid, isnews) {
            $('#bcomment').prop('disabled', true);
            let cbody = $(`#cfrm${mid} textarea[name=cbody]`).val();
            Ajax.comment(mid, isnews ? 'yes' : 'no', cbody, function(res) {
                if (res.success != 'ok') {
                    $('#bcomment').prop('disabled', false);
                    return;
                }
                if (isnews) {
                    Ajax.getMatchTab(
                        mid,
                        'comments_news',
                        function(data) {
                            $('#tab_comments').html(data.html);
                            Generic.init_gifemoji_enabled_input();
                            UserMention.init();
                        }
                    );
                } else {
                    if (Generic.mobile) {
                        Ajax.getMatchTab(
                            mid,
                            'comments',
                            function(data) {
                                $('#comments-' + mid).html(data.html);
                                Generic.init_gifemoji_enabled_input();
                                UserMention.init();
                            }
                        );
                    } else {
                        DesktopMatch.tabLoad('comments', mid);
                    }
                }
            });
        },
        expandHiddenComment: function(event, commentId){
            event.preventDefault();
            $('#cmt_hidden_' + commentId).remove();
            $('#cmt_' + commentId).show();
        },
        commentVote: function(event, commentId, upDown, isnews){
            event.preventDefault();
            Ajax.voteComment(commentId, upDown, isnews, function(res) {
                if (res.success == 'ok') {
                    $(event.target).parent().parent().find('.ii__commentscore').text(res.newScore);
                    if (res.upDown === 1) {
                        $(event.target).parent().addClass('clr-green');
                        $(event.target).parent().parent().find('.ii__votedown').removeClass('clr-red');
                    } else if (res.upDown === -1){
                        $(event.target).parent().addClass('clr-red');
                        $(event.target).parent().parent().find('.ii__voteup').removeClass('clr-green');
                    } else {
                        $(event.target).parent().parent().find('.ii__vote').each(function(i, e) {
                            $(e).removeClass('clr-red').removeClass('clr-green');
                        });
                    }
                }
            });
        },
        show_register_username_modal: function(g_register) {
            if ($('#register-username-form-container').length > 0) {
                $('#register-username-form-container').remove();
            }
            $('body').append('<div class="modal fade" id="register-username-form-container" tabindex="-1" role="dialog" aria-hidden="true">\
        <div class="modal-dialog" role="document">\
            <div class="modal-content">\
                <div class="modal-header">\
                    <h3 class="modal-title">Εγγραφή νέου χρήστη - Επιλέξτε όνομα χρήστη (username)</h3>\
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                        <span aria-hidden="true">&times;</span>\
                    </button>\
                </div>\
                <div class="modal-body">\
                    <form id="register-username-form" method="post">\
                        <label>Όνομα χρήστη (Username): </label>\
                        <input type="text" class="form-control" name="username" id="newusername">\
                        <input id="g_register" type="hidden" value="' + g_register + '">\
                        <br>\
                        <br>\
                        <input id="user-newsletter" name="newsletter" type="checkbox" value="1"/>\
                        <label for="user-newsletter" style="display:inline;font-size:11px;">\
                            Συμφωνώ να λαμβάνω νέα από το Agones.gr μέσω ηλεκτρονικής αλληλογραφίας\
                        </label><br>\
                        <input id="user-optin" type="checkbox" value="1"/>\
                        <label for="user-optin" style="display:inline;font-size:11px;">Συμφωνώ με τους \
                            <a href="/terms" target="_blank">Όρους χρήσης</a> και την <a href="/terms" target="_blank">Πολιτική χρήσης δεδομένων</a></label>\
                        <br><br>\
                        <span id="register-username-btn" class="btn btn-primary" style="cursor:pointer;">Εγγραφή</span>\
                    </form>\
                </div>\
            </div>\
        </div>\
    </div>');
            Account.init();
            $('#register-username-form-container').modal();
        },

        alert: function(title, msg, html = false) {
            $('.modal').modal('hide'); // You are about to show a modal. Make sure to hide any other visible modal first
            if ($('#generic-alert-container').length == 0) {
                $('body').append('<div class="modal fade" id="generic-alert-container" tabindex="-1" role="dialog" aria-hidden="true">\
        <div class="modal-dialog" role="document">\
            <div class="modal-content" style="top:30px;">\
                <div class="modal-header">\
                    <h3 class="modal-title"></h3>\
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                        <span aria-hidden="true" style="font-size:24px;">&times;</span>\
                    </button>\
                </div>\
                <div class="modal-body">\
                </div>\
            </div>\
        </div>\
    </div>');
            }
            if (!html) {
                $('#generic-alert-container .modal-title').text(title);
                $('#generic-alert-container .modal-body').text(msg);
            } else {
                $('#generic-alert-container .modal-title').html(title);
                $('#generic-alert-container .modal-body').html(msg);
            }
            $('#generic-alert-container').modal();
        },
        jsCookies: {
            getItem: function(sKey) {
                return decodeURIComponent(
                    document.cookie.replace(
                        new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')
                ) || null;
            },
            setItem: function(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
                if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
                    return false;
                }
                var sExpires = '';
                if (vEnd) {
                    switch (vEnd.constructor) {
                    case Number:
                        sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
                        break;
                    case String:
                        sExpires = '; expires=' + vEnd;
                        break;
                    case Date:
                        sExpires = '; expires=' + vEnd.toUTCString();
                        break;
                    }
                }
                document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires +
                    (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
                return true;
            },

            removeItem: function(sKey, sPath, sDomain) {
                if (!sKey || !this.hasItem(sKey)) {
                    return false;
                }
                document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
                    ( sDomain ? '; domain=' + sDomain : '') + ( sPath ? '; path=' + sPath : '');
                return true;
            },
            hasItem: function(sKey) {
                return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
            },
            keys: /* optional method: you can safely remove it! */ function() {
                var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
                for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
                    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
                }
                return aKeys;
            }
        },
        init_submenus: function() {
            $('.dropdown-submenu .dropdown-toggle:not(.submenu-inited)').each(function(i, elem) {
                $(elem).addClass('submenu-inited');
                $(elem).on('click', function(e) {
                    var hasclass = $(this).next('.dropdown-menu').hasClass('show');
                    $('.dropdown-submenu .dropdown-menu').removeClass('show');
                    if (hasclass) {
                        $(this).next('.dropdown-menu').removeClass('show');
                    } else {
                        $(this).next('.dropdown-menu').addClass('show');
                    }
                    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
                        $('.dropdown-submenu .show').removeClass('show');
                    });
                }).parent().focusout(function() {
                    setTimeout(function(elem) {
                        elem.find('.dropdown-menu').removeClass('show');
                    }, 500, $(this));
                });
            });
        },
        init_popovers: function() {
            // !important!: this function is called multiple times, so all events must be turned off() and then on()
            // otherwise we end up with multiple calls

            // remove previous pop-ups
            $('.popover.pop.show').remove();

            if (Generic.mobile) {
                // hide popover only when touching outside of it
                $(document).off('touchend').on('touchend', function(event) {
                    var hide = true;

                    if ($(event.target).hasClass('popover')) {
                        hide = false;
                    } else {
                        $(event.target).parents().each(function(i, e) {
                            if ($(e).hasClass('popover')) {
                                hide = false;
                            }
                        });
                    }

                    if (hide) {
                        $('.popover').popover('hide');
                    }
                });
            }

            $('.ii__popover[data-toggle="popover"]').each(function(i, e) {

                if (!Generic.mobile) {
                    $(e).off('shown.bs.popover').on('shown.bs.popover', function() {
                        // If the mouse is not hovering the popover trigger element (moved out too fast),
                        // we'll never get a mouseleave event and the popover will stay permantently shown.
                        // So if it's not hovering, let's hide the popover right away.
                        if (!$(this).is(':hover')) {
                            $(this).popover('hide');
                        } else {
                            $(this).off('mouseleave').on('mouseleave', function() {
                                $(this).popover('hide');
                            });
                        }
                    });
                }

                $(e).off('mouseenter touchend').on('mouseenter touchend', function() {
                    var url = $(this).data('url');
                    var extraclass = $(this).data('extraclass') ? $(this).data('extraclass') : '';
                    var basePopoverTemplate = ('<div class="popover pop ' + extraclass + '" role="tooltip">' +
                                               '<div class="arrow"></div>' +
                                               '<h3 class="popover-header pop__header pop__title"></h3>' +
                                               '<div class="popover-body"></div></div>');
                    if (url) {
                        var this_ = this;
                        Ajax.get(url, function(res) {
                            if (res.success != 'ok') {
                                return;
                            }
                            $(this_).popover({
                                html: true,
                                placement: function(pop, elem){
                                    // 'auto' placement is 99% of the times fine, but it occasionally
                                    // goes full retard hence the override hack here.
                                    var elem_x = $(elem)[0].getBoundingClientRect().left;
                                    var elem_y = $(elem)[0].getBoundingClientRect().top;
                                    var left = elem_x;
                                    var right = $(window).width() - elem_x;
                                    var top = elem_y;
                                    var bottom = $(window).height() - elem_y;
                                    if (left > right && left > top && left > bottom) {
                                        return 'left';
                                    } else if (right > left && right > top && right > bottom) {
                                        return 'right';
                                    } else if (top > left && top > right && top > bottom) {
                                        return 'bottom';
                                    } else {
                                        return 'top';
                                    }
                                },
                                trigger: 'manual',
                                boundary: 'window',
                                animation: false, // fading causes never ending closing/opening popovers in some browsers
                                template: basePopoverTemplate,
                                content: res.html,
                                sanitizeFn: function(content) {
                                    // disable html sanitization
                                    return content;
                                }
                            }).popover('show');
                        });
                    } else {
                        $(this).popover({
                            html: true,
                            placement: 'auto',
                            trigger: 'manual',
                            animation: true,
                            template: basePopoverTemplate
                        }).popover('show');
                    }
                });
            });
        },
        parseNumericInput: function(num) {
            num = num.replace(',', '.').trim();
            num = isNaN(num)
                || num.toLowerCase().includes('infinity')
                || num.toLowerCase().includes('e')
                || num.toLowerCase().includes('x')
                || num.toLowerCase().includes('b')
                || num.toLowerCase().includes('n')
                || num.includes('+')
                || num.includes('-')
                ? -1
                : num;
            num = parseFloat(num);
            return isNaN(num) ? -1 : num;
        },
        legacyBrowserFixes: function() {
            (function() {
                var vendors = ['webkit', 'moz', 'ms', 'o'], vp = null;
                for (var x = 0; x < vendors.length && !window.requestAnimationFrame && !window.cancelAnimationFrame; x++) {
                    vp = vendors[x];
                    window.requestAnimationFrame = window.requestAnimationFrame || window[vp + 'RequestAnimationFrame'];
                    window.cancelAnimationFrame = (window.cancelAnimationFrame ||
                                                   window[vp + 'CancelAnimationFrame'] ||
                                                   window[vp + 'CancelRequestAnimationFrame']);
                }
                if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
                    var lastTime = 0;
                    window.requestAnimationFrame = function(callback, element) {
                        var now = window.performance.now();
                        var nextTime = Math.max(lastTime + 16, now); //First time will execute it immediately but barely noticeable and performance is gained.
                        return setTimeout(function() {
                            callback(lastTime = nextTime);
                        }, nextTime - now);
                    };
                    window.cancelAnimationFrame = clearTimeout;
                }
            }());
        },
        retargetingPromo: function() {
            if (!Generic.jsCookies.hasItem('NORET') &&
                Generic.jsCookies.hasItem('ADCL')) {
                var adcl = Generic.jsCookies.getItem('ADCL').split(',');
                if (adcl.length == 2) {
                    var dt = Math.round(new Date().getTime() / 1000) - adcl[1];
                    if (dt > 1800) {
                        Ajax.getPromoModal(adcl[0], function(res) {
                            if (res.success == 'ok' && res.data.title && res.data.body) {
                                Generic.jsCookies.removeItem('ADCL', '/');
                                Generic.jsCookies.setItem('NORET', '1', 2592000, '/');
                                Generic.alert(res.data.title, res.data.body, true);
                            }
                        });
                    }
                }
            }
        },
        delayed_init: function() {
            Generic.init_popovers();
            Generic.init_gifemoji_enabled_input();
            if ($('#show-description-btn').length > 0) {
                $('#show-description-btn').click(function() {
                    $('#description-snippet').hide();
                    $('#description-full').show();
                });
            }
            // light / dark theme
            $('.ii__theme').click(function() {
                Generic.toggle_theme();
            });
            Search.init();
            // init datepicker
            if ($('#currday').length > 0) {
                DatePicker.init();
                DatePicker.bind();
            }
            setTimeout('Generic.retargetingPromo();', 5000);
        },
        hideCookieVotes: function() {
            var voteGroups = {
                '1': 'ii__vb',
                'X': 'ii__vb',
                '2': 'ii__vb',
                'H': 'ii__vb',
                'B': 'ii__vb',
                'A': 'ii__vb',
                'O': 'ii__vbO',
                'U': 'ii__vbO',
                'Q': 'ii__vbO',
                'W': 'ii__vbO',
                'E': 'ii__vbO',
                'R': 'ii__vbO',
                '3': 'ii__vbT',
                '4': 'ii__vbT',
                '5': 'ii__vbT',
                'G': 'ii__vbG',
                'N': 'ii__vbG',
            };
            var votes = {};
            if (Generic.jsCookies.hasItem('userVotes')) {
                votes = Generic.jsCookies.getItem('userVotes');
                votes = decodeURIComponent(votes);
                votes = JSON.parse(atob(votes));
            } else {
                votes = {};
            }
            for (var id in votes) {
                for (var x in votes[id]) {
                    var vote = votes[id][x];
                    $('.' + voteGroups[vote] + id).attr('disabled', 'disabled');
                    $('#bvote' + vote + id).removeClass('btn-light').addClass('btn-primary');
                }
            }
        },
        updateTimes: function() {
            var clientTzOffsetHours = -(new Date()).getTimezoneOffset() / 60;
            if (window.defaultTzOffsetHours === clientTzOffsetHours) {
                return;
            }
            var diff = clientTzOffsetHours - window.defaultTzOffsetHours,
                anyDateObj = new Date(),
                targetClass = 'ii__localtime';
            $('.' + targetClass).html(function(index, currentContent) {
                currentContent = currentContent.trim();
                var parts = currentContent.split(' ');
                var timeParts = parts[parts.length - 1].split(':');  // make compatible with date-time
                var hours = parseInt(timeParts[0]),
                    minutes = timeParts[1];
                anyDateObj.setHours(hours + diff);  // works correctly with < 0 & > 23 values
                var newHours = anyDateObj.getHours();
                return (parts.length > 1 ? parts[0] + ' ' : '')
                    + (newHours < 10 ? '0' : '') + newHours.toString() + ':' + minutes;
            }).removeClass(targetClass);
        },
        localizeContent: function() {
            if (!Generic.country) {
                return;
            }
            $('.country-filtered').hide();
            $('.country-filtered.c-' + Generic.country).show();

            // if all .country-filtered elements in a container are hidden,
            // hide the container as well
            $('.country_filtered_container').each(function() {
                if ($(this).find('.country-filtered:visible').length == 0) {
                    $(this).hide();
                }
            });
        },
        recordWebvitals: function({name, value, id, attribution}) {
            const {eventEntry, eventTarget, eventType, loadState} = attribution;
            const {startTime, processingStart, processingEnd, duration, interactionId} = eventEntry;
            const eventParams = {
                metric_inp_value: value,
                metric_id: id,
                metric_inp_event_target: eventTarget,
                metric_inp_event_type: eventType,
                metric_inp_load_state: loadState,
                metric_inp_start_time: startTime,
                metric_inp_processing_start: processingStart,
                metric_inp_processing_end: processingEnd,
                metric_inp_duration: duration,
                metric_inp_interaction_id: interactionId,
                url: window.location.href,
                is_mobile: Generic.mobile
            };
            if (Generic.webvitalsSampleRate == 1) {
                console.log(eventTarget,': ', value);
            }
            Ajax.recordWebvitals(eventParams);
        },
        initWebvitals: function(sample_rate) {
            Generic.webvitalsSampleRate = sample_rate;
            if (Math.random() < sample_rate) {
                window.onINP(Generic.recordWebvitals, {reportAllChanges: sample_rate == 1});
            }
        },
        initFirstViewData: (firstview_data) => {
            Generic.firstview_customer_id = firstview_data.firstview_customer_id;
            Generic.firstview_player_id = firstview_data.firstview_player_id;
            Generic.firstview_gallery_player_id = firstview_data.firstview_gallery_player_id;
            Generic.firstview_gallery_playlist_id = firstview_data.firstview_gallery_playlist_id;
        },
        init: function(
            country,
            loggedin,
            theme,
            default_pinned_leagues,
            sentry_js_url,
            sentry_js_sample_rate,
            mobile,
            tenor_api_key,
            firstview_data,
            svg_icons_path
        ) {
            var saved_scroll = localStorage['scroll'];
            if (saved_scroll) {
                $(window).scrollTop(saved_scroll);
                localStorage.removeItem('scroll');
            }
            Generic.mobile = mobile ? 1 : 0;
            Generic.sentry_js_url = sentry_js_url;
            Generic.tenor_api_key = tenor_api_key;
            Generic.initFirstViewData(firstview_data);
            Generic.svg_icons_path = svg_icons_path;

            if (Math.random() < sentry_js_sample_rate) {
                Generic.loadScript('https://browser.sentry-cdn.com/5.9.1/bundle.min.js' , function() {
                    if (Sentry != undefined) {
                        Generic.sentry = true;
                        Sentry.init({dsn: Generic.sentry_js_url});
                    }
                });
            } else {
                Generic.sentry = false;
            }
            Generic.default_view = -1; // -1: undefined, 0: kouponi, 1: all
            Generic.show_more_button_inited = false;
            Generic.show_all_button_inited = false;
            Generic.country = country;
            Generic.loggedin = loggedin;
            Generic.default_pinned_leagues = default_pinned_leagues;
            Generic.theme = theme;
            Generic.legacyBrowserFixes();
            Generic.updateTimes();
            Generic.localizeContent();
            setTimeout('Generic.delayed_init();', 500);
            Subscribe.init();
            Account.init_handlers();
            Generic.handleTabClickSroll();

            // visits cookie
            Generic.visitCount = 1;
            if (Generic.jsCookies.hasItem('FIRSTTIMEVISITOR')) {
                Generic.visitCount = parseInt(Generic.jsCookies.getItem('FIRSTTIMEVISITOR')) * 1 + 1;
            }
            Generic.jsCookies.setItem('FIRSTTIMEVISITOR', Generic.visitCount, 3600 * 24 * 90, '/');

            $(document.body).on('click', '.ii__clickable_element', (function() {
                window.location = $(this).data('href');
            }));
        },
        sliceObject: function(obj, maxLength) {
            var total = Object.keys(obj).length;
            if (total > maxLength) {
                var keep = -Math.abs(total - maxLength);
                var filteredKeys = Object.keys(obj).slice(0, keep);
                var newObj = {};
                filteredKeys.forEach(function(key){
                    newObj[key] = obj[key];
                });
                obj = newObj;
            }
            return obj;
        },
        // Function to relace query params from window.location compatible with old browsers like IE
        // input:
        //      name ->  Name of param to be replaced
        //      value ->  New value for given key
        // Returns a string with all query parameters, with specified key updated
        setParam: function(name, value){
            var matchRegEx = new RegExp(name + '=([^&#]*)'),
                newParam = name + '=' + String(value),
                qParams = top.location.search;

            if ( qParams.length === 0){
                return '?' + newParam;
            } else if (qParams.match(matchRegEx) == null) {
                return qParams + '&' + newParam;
            } else {
                return qParams.replace(matchRegEx, newParam);
            }
        },
        getParam: function(name) {
            if (window.location.search.length == 0) {
                return null;
            }
            const qStr = window.location.search.substring(1);
            const tokens = qStr.split('&');
            const params = {};
            for (const token of tokens) {
                let [key, val] = token.split('=');
                params[key] = val;
            }
            return params[name];
        },
        /**
         * Check if field is empty, focus and alert
         */
        hasMinChars: function(fld, min_chars) {
            if (min_chars === undefined) {
                min_chars = 1;
            }

            if (fld.value.length < min_chars) {
                var s = 'Υποχρεωτικό πεδίο';
                if (min_chars > 1) {
                    s += '. Δώστε τουλάχιστον ' + min_chars + ' χαρακτήρες...';
                }
                Generic.showError(fld, s);
                return false;
            }

            Generic.hideError(fld);
            return true;
        },
        /**
         * Display an error for a field
         */
        showError: function(fld, msg) {
            alert(msg);
            fld.focus();
            fld.style.borderColor = '#ff0000';
        },
        /**
         * Hide an error
         */
        hideError: function(fld) {
            fld.style.borderColor = '';
        },
        /**
         * Check for allowed username chars
         */
        isUsername: function(str) {
            var re = /^[a-z0-9][a-z0-9._-]+[a-z0-9]$/i;
            var f = str.match(re);
            if (f != str) {
                return false;
            }

            if (str.split('.').length - 1 + str.split('_').length - 1 + str.split('-').length - 1 > 1) {
                return false;
            }

            return true;
        },
        /**
         * Check for valid email
         */
        isEmail: function(str) {
            if (str.search(/^[A-Z0-9._-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i) == -1) {
                return false;
            }
            return true;
        },
        /**
         * Check for email existence
         */
        checkEmail: function(async, current) {
            if (document.frm.email.value == current) {
                $('#check_email').html('');
                return;
            }
            Ajax.checkEmail(document.frm.email.value, async, function(res) {
                if (res.success == 'ok') {
                    $('#check_email').html(res.html || '');
                }
            });
        },
        /**
         * Check for username existence
         */
        checkUsername: function(async, current) {
            if (document.frm.username.value == current) {
                $('#check_username').html('');
                return;
            }

            Ajax.checkUsername(document.frm.username.value, async, function(res) {
                if (res.success == 'ok') {
                    $('#check_username').html(res.html || '');
                }
            });
        },
        moderate: function(user_id, interval, onsuccess) {
            if (typeof onsuccess == 'undefined') {
                onsuccess = function() {
                    top.location.href = top.location.href;
                };
            }
            Ajax.moderate(user_id, interval, onsuccess);
        },
        specialAd: function(bannerId, mobileThreshold, desktopThreshold) {
            let cookie = {};
            if (Generic.jsCookies.hasItem('SPECIALAD2')) {
                cookie = JSON.parse(Generic.jsCookies.getItem('SPECIALAD2'));
                if (Object.keys(cookie).length > 20) {
                    // prune cookie if it gets too big
                    cookie = {};
                }
                if (cookie[bannerId] != undefined) {
                    cookie[bannerId] = parseInt(cookie[bannerId]) * 1 + 1;
                } else {
                    cookie[bannerId] = 1;
                }
            } else {
                cookie[bannerId] = 1;
            }
            if ((Generic.mobile && cookie[bannerId] > mobileThreshold) ||
                (!Generic.mobile && cookie[bannerId] > desktopThreshold)) {
                return;
            }
            $('#specialad').show();
            Generic.jsCookies.setItem('SPECIALAD2', JSON.stringify(cookie), 3600 * 24 * 7, '/');
        },
        showProgressLoader: function() {
            $('.ii__progress_line').css('display', 'flex');
        },
        hideProgressLoader: function() {
            $('.ii__progress_line').css('display', 'none');
        },
        showFeedback: function(msg) {
            var bottom = '30';
            if (typeof MobileGeneric !== 'undefined' && MobileGeneric.sticky_footer_visible) {
                bottom = '100';
            }
            $('.ii__feedback').css('bottom', bottom + 'px');
            $('.ii__feedback').html(msg);
            $('body').addClass('feedback-on');
            clearTimeout(Generic._feedbackTimeoutID); // stop old timeout
            Generic._feedbackTimeoutID = setTimeout(function() {
                $('body').removeClass('feedback-on');
            }, 2500);
        },
        handleTabClickSroll: () => {
            $(document).on('shown.bs.tab', '.ii__tab_nav', function() {
                let scroll_offset = parseInt($(this).parents().find('nav').data('scroll_offset'));
                if (!scroll_offset) {
                    return;
                }
                let scrollto = $('.tab-content').offset().top - scroll_offset;
                if ($(document).scrollTop() > scrollto) {
                    $(document).scrollTop(scrollto);
                }
            });
        },
        loadScript: (url, cb) => {
            const scriptElem = document.createElement('script');
            scriptElem.type = 'text/javascript';
            scriptElem.async = 1;
            scriptElem.onload = scriptElem.onreadystatechange = cb;
            scriptElem.src = url;
            document.head.appendChild(scriptElem);
        },
        handleOverlay: (show) => {
            // toggle overlay visibility directly with css to avoid css reparsing #INP_optimization
            if (show) {
                document.body.style.overflow = 'hidden';
                document.getElementById('page_overlay').style.transform = 'translateX(0)';
            } else {
                document.body.style.overflow = 'initial';
                document.body.style['overflow-x'] = 'hidden';
                document.getElementById('page_overlay').style.transform = 'translateX(100%)';
            }
        }
    };
}();

Generic.animated_gif_cnt = 36;
Generic.emojis = [
    '😓','😔','😕','🙃','🤑','😲','🙁','😖','👍','👎','👆','🍆','🏀','🎾','🏐',
    '🚀','🏖','🏝','🗑','🛢','💸','💵','💴','💶','💷','💰','💳','💎',
    '🇬🇷','💡','🧯','🌋','🏦','🚑','🛴','🛫','🛸','🌯','🍫','🍿',
    '🍻','💥','🌧','🐑','👏','🙏', '💩','🙌', '🎯', '🥁', '🎪'
];

if (typeof module !== 'undefined') {
    module.exports = Generic;
}
